var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stock", {
        ref: "stock",
        attrs: { searchObj: _vm.searchObj, stockTypeObj: _vm.stockTypeObj },
        on: { postListData: _vm.postListData },
        scopedSlots: _vm._u([
          {
            key: "searchDiv",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "secondSearchLine" },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "1.5rem" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        size: "mini",
                        type: "date",
                        placeholder: "选择日期",
                      },
                      model: {
                        value: _vm.searchObj.date,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchObj, "date", $$v)
                        },
                        expression: "searchObj.date",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "contentDiv",
            fn: function () {
              return _vm._l(_vm.dataList, function (item, index) {
                return _c("div", { key: index }, [
                  item.productType == 2
                    ? _c(
                        "div",
                        [
                          _c("exclusive-stock", {
                            attrs: { keyStr: _vm.keyStr, productObj: item },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "contentDiv" },
                        [
                          _c("hotel-resource-left", {
                            staticClass: "contentHead",
                            attrs: {
                              productObj: item,
                              showTag: false,
                              btnName: "加入行程",
                              btnName1: "询",
                            },
                            on: {
                              exclusiveAddYsP: function ($event) {
                                return _vm.exclusiveAddYsP(item)
                              },
                              inquiryResource: _vm.inquiryResource,
                            },
                          }),
                        ],
                        1
                      ),
                ])
              })
            },
            proxy: true,
          },
        ]),
      }),
      _c("create-product-dialog", {
        ref: "createProduct",
        attrs: { keyStr: _vm.keyStr, searchDate: _vm.searchObj.date },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }